module.exports = __webpack_public_path__ + "img/svg/background-about-us.fb03fad102ba5b869310a7eeb3d000c2.svg";